function getScrollbarWidth() {
  let scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--sw', scrollBarWidth + 'px');
}

runIfElementExist(getScrollbarWidth, 'body');

resizeTimer(getScrollbarWidth, 'body', 250);
